import type { SxProps, Theme } from "@mui/material"
import { InsertDriveFileOutlined } from "@mui/icons-material"
import type { ChatDataMessagePart, ChatFileMessagePart, ChatPartRendererProps } from "@mui/x-chat-headless"
import { AttachmentChip, attachmentDetail } from "./attachment-chip"
import { narrowAttachment } from "./attachments-transport"

const SENT_CHIP_SX = { marginBlock: 0.5 } satisfies SxProps<Theme>

export function AttachmentFilePart({ part }: ChatPartRendererProps<ChatDataMessagePart>) {
  const attachment = narrowAttachment(part.data)
  if (attachment === null) return null

  return (
    <AttachmentChip
      data-testid="kelly-sent-attachment"
      sx={SENT_CHIP_SX}
      icon={<InsertDriveFileOutlined fontSize="small" color="action" />}
      name={attachment.filename}
      detail={attachmentDetail(attachment.filename, attachment.mediaType, attachment.sizeBytes)}
    />
  )
}

export function FileMessagePart({ part }: ChatPartRendererProps<ChatFileMessagePart>) {
  const filename = part.filename ?? "Attachment"

  return (
    <AttachmentChip
      data-testid="kelly-sent-attachment"
      sx={SENT_CHIP_SX}
      icon={<InsertDriveFileOutlined fontSize="small" color="action" />}
      name={filename}
      detail={attachmentDetail(filename, part.mediaType)}
    />
  )
}
